"use client";

import { useEffect, useState } from "react";

export function useHydration() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
    
    // Add a class to the body to indicate hydration is complete
    document.body.classList.add('hydrated');
    
    return () => {
      document.body.classList.remove('hydrated');
    };
  }, []);

  return isHydrated;
}

export function useClientOnly() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted;
}
